module.exports = __webpack_public_path__ + "img/2026_01_student-success.ea34db84.webp";